import React, { useState, useEffect } from "react";
//methods and elements
import { sendGetRequest, sendGetRequestApi } from "../../services/service";
import { config} from "../../config/dev";
import { Row, Col, CardBody, Input, Button } from "reactstrap";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//libraries
import Breadcrumbs from "../../components/Common/Breadcrumb";
// import TablePagination from "../../common/TablePagination";
import { Link } from "react-router-dom";
import AssessmentSessionsOffCanvas from "../../components/assessmentsessions/AssessmentSessionsOffCanvas";
import CustomTable from "../../common/CustomTable";
import CandidatesOffCanvas from "../../components/candidates/CandidatesOffCanvas";
import moment from "moment/moment";
import { ToastContainer ,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import TableLoader from "../../components/Common/TableLoader";
import CandidateInviteCanvas from "../../components/assessmentsessions/SendInviteCanvas";
function AssessmentSessions() {
  // const [state, setState] = useState("");
  const [assessments, setAssessments] = useState([]);
  const [isPreloader, setIsPreloader] = useState(false);
  const [searchedWord, setSearchedWord] = useState("");
  const [assmntData, setAssmntData] = useState("");
  const [isAssessmentRightCanvas, setIsAssessmentRightCanvas] = useState(false);
  const [isRightCandidatesCanvas, setIsRightCandidatesCanvas] = useState(false);
  const [candidateProfileDetails, setCandidatesProfileDetails] = useState({});
  const [candidateGuid, setCandidateGuid] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCounts , setTotalCounts] = useState(10);
  const [isInviteCanvasOpen, setIsInviteCanvasOpen] = useState(false);

  let SearchedValue = "";
  let defaultAssmntData = [];
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const columns = [
    {
      Header: "Name",
      accessor: "candidateId",
      Cell: ({ row }) => (
        <Link
          to="#"
          style={{ cursor: "pointer", textDecoration: "underline" }}
          // onClick={() =>
          //   on_click_candidte_name(row.original)
          // }
          onClick={() => on_click_assmnt_role(row.original)}
        >
          {row.original?.candidateId?.name?.fullName ? row.original?.candidateId?.name?.fullName
            : "-"}
        </Link>
      ),
    },
    {
      Header: "Role",
      accessor: "role",
      Cell: ({ row }) => (
        // <Link
        //   to="#"
        //   style={{ cursor: "pointer", textDecoration: "underline" }}
        //   onClick={() => on_click_assmnt_role(row.original)}
        // >
        <p>
          {row.original.role}
          </p>
        // </Link>
      ),
    },
    {
      Header: "Primary Skills",
      accessor: "primary_skills",
      Cell: ({ row }) =>
        row.original.primary_skills && row.original.primary_skills.length > 0 ? (
          // <ul style={{ padding: '1rem' }}>
          <>
            {" "}
            {row.original.primary_skills.map((skill, index) => (
              <span key={index} className="bg-success badge me-1 bg-primary">
                {skill.title}
              </span>
            ))}
          </>
        ) : (
          // </ul>
          "-"
        ),
    },

    {
      Header: "Score",
      accessor: "tiqScore",
      Cell: ({ row }) =>
        row.original.tiqScore && row.original.status === "completed" ? (
          <div style={{ width: "40px", height: "40px" }}>
          {" "}
          <CircularProgressbarWithChildren
            styles={{
              root: {}, // Adjust these values
              path: {
                stroke: "#5156be",
                strokeLinecap: "round",
                transition: "stroke-dashoffset 0.5s ease 0s",
                transform: "rotate(0.25turn)",
                transformOrigin: "center center",
                pathColor: "#74788d",
              },
              trail: {
                stroke: "#d6d6d6",
                strokeLinecap: "round",
                transform: "rotate(0.25turn)",
                transformOrigin: "center center",
              },
            }}
            value={ row.original.tiqScore.toFixed(2)}
          >
            <div style={{ fontSize: 9 }}>
              <strong>
                {
                  (row.original.tiqScore.toFixed(0))} %
              </strong>
            </div>
          </CircularProgressbarWithChildren>
        </div>
        ) : (
          "-"
        ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <span
          className={`bg-success badge ${row.original.status === "completed"
              ? "bg-success"
              : row.original.status === "initiated"
                ? "bg-primary"
                : "bg-warning"
            }`}
        >
          {row.original.status}
        </span>
      ),
    },
    {
      Header: "Start Date",
      accessor: "createdAt",
      Cell: ({ row }) => (
        <span>{moment(row.original.createdAt).format("DD MMM,YYYY")}</span>
      ),
    },
    // {
    //   Header: "Action",
    //   accessor: "",
    //   Cell: ({ row }) => (
    //     <>
    //     <div className="text-center">
    //     <Button color="primary"><i className="mdi mdi-email me-1"/>Invite</Button>
    //     </div>
    //     </>
    //   ),
    // },
  ];
  useEffect(() => {
    setIsPreloader(true)
    sendGetRequestApi(`/assessment?limit=10&skip=${currentPage}`).then((response) => {
      
      if(response?.status === 200){
        console.log("assessmentDetails",response)
        setAssessments(response?.data);
        setIsPreloader(false)
        setTotalCounts(response?.pagination?.totalCount)
      }
    })
  }, [currentPage])
  
  const handleSearchOnEnter = (event) => {
    if (event.key === "Enter") {
      // Perform your search logic here
      handleClick();
    }
  };

  function handleSearchedVal(event) {
    if(event.target.value === '' || null || undefined){
      
      setSearchedWord('')
    }else{
      SearchedValue = event.target.value;

    }
  }
  const handleClick = (event) => {
    setSearchedWord(SearchedValue);
    // 👇️ value of input field
  };
  const on_click_assmnt_role = (assmntData) => {
    setAssmntData(assmntData?._id);
    setIsAssessmentRightCanvas(!isAssessmentRightCanvas);
  };
  const on_click_candidte_name = (assmntDetails) => {
    // setCandidate_assmnt_sess_details({});
    setCandidatesProfileDetails(assmntDetails);
    // setCandidateGuid(candidate_guid);
    setIsRightCandidatesCanvas(!isRightCandidatesCanvas);
  };

  const handleCandidateInvite = () => {
    console.log("entered the invite handler");
    setIsInviteCanvasOpen(true);

  }

  //meta title
 document.title = "TalentIQ";

  return (
    <React.Fragment>
      
      <ToastContainer/>
      <div className="page-content">
        <div className="container-fluid">
          <div className="hstack gap-3 mb-2 mt-0">

            <Breadcrumbs title="Assessments" />
          </div>

          <Row>
            
            <Col>
              {/* <Card> */}

              <CardBody>
                <div className="table-rep-plugin">
                  <div
                    className="mb-0"
                    data-pattern="priority-columns"
                  >
                   {assessments.length > 0 ? (<CustomTable
                   totalCount={totalCounts}
                   currentPage={currentPage}
                    data={assessments}
                    onPageChange={handlePageChange}
                     columns={columns} 
                     isloading={!isPreloader}
                     showInvite={true}
                     onInviteCandidate={handleCandidateInvite}
                     />) : <TableLoader/>}
                    {/* {
                      filteredAssessments.length > 0 ? (
                        <CustomTable data={filteredAssessments} columns={columns} />
                      ) : (<div className="hstack">
                         <Skeleton variant="wave" animation="pulse" className="mb-2 me-2" width={300} height={15} />
                        <Skeleton variant="wave" animation="pulse" className="mb-2 me-2" width={300} height={15} />
                        <Skeleton variant="wave" animation="pulse" className="mb-2 me-2" width={300} height={15} />
                        <Skeleton variant="wave" animation="pulse" className="mb-2 me-2" width={300} height={15} />
                        <Skeleton variant="wave" animation="pulse" className="mb-2 me-2" width={300} height={15} />
                      </div>
                      
                       
                      )
                      } */}

                  </div>
                </div>
              </CardBody>
              {/* </Card> */}
            </Col>
          </Row>
          {isRightCandidatesCanvas && (
            <CandidatesOffCanvas
              is_Right={isRightCandidatesCanvas}
              // candidate_guid={candidateGuid}
              toggleRightCanvas={on_click_candidte_name}
              candidateProfileDetails={candidateProfileDetails}
            />
          )}
        </div>
        {isAssessmentRightCanvas && (
          <AssessmentSessionsOffCanvas
            is_Right={isAssessmentRightCanvas}
            toggleRightCanvas={on_click_assmnt_role}
            assmntGuid={assmntData}
          />
        )}

        {isInviteCanvasOpen && (
          <CandidateInviteCanvas
          isOpen={isInviteCanvasOpen}
          toggleRightCanvas={() => setIsInviteCanvasOpen(!isInviteCanvasOpen)}
          />
        )}
      </div>
    </React.Fragment>
  );
}

export default AssessmentSessions;
